module.exports = __webpack_public_path__ + "static/media/geometry_3@2x.7234854d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/personalProject/geometry_3@2x.png
// module id = 191
// module chunks = 0